import React from 'react';
import { observer } from 'mobx-react';
import { Form, Formik } from 'formik';
import { Button, Modal } from 'react-bootstrap';

import { SaveButton } from 'src/libs/ui-kit/buttons/SaveButton';
import { useStore } from 'src/modules/users/hooks/useStore';

import { INITIAL_VALUES } from '../constants';

import { CustomerLoyaltyForm } from './CustomerLoyaltyForm';
import { ReasonSelect } from './ReasonSelect';
import { StoreContext } from './StoreProvider';

export const CustomerLoyaltyModal = observer(() => {
  const store = useStore(StoreContext);

  return (
    <Formik initialValues={INITIAL_VALUES} onSubmit={store.createNewOperation}>
      <Modal className="modal-slide" show={store.isBonusFormModalOpened} onHide={store.closeBonusModal}>
        <Modal.Header closeButton>
          <Modal.Title as="h5">Изменить счёт</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <div className="mt-2">
              <ReasonSelect />
              <CustomerLoyaltyForm />
            </div>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <SaveButton>Подтвердить</SaveButton>
          <Button variant="secondary" onClick={store.closeBonusModal}>
            Отменить
          </Button>
        </Modal.Footer>
      </Modal>
    </Formik>
  );
});
